<script setup>
  import { computed } from 'vue';
  import { useProForecastStore } from '@/stores/ProForecastStore';
  import ProForecastHeader from '@/components/ProForecastHeader.vue';
  import ProForecastBodyDaily from '@/components/ProForecastBodyDaily.vue';
  import ProForecastBodyNextUpdateMessage from '@/components/ProForecastBodyNextUpdateMessage.vue';
  import ProForecastFooter from '@/components/ProForecastFooter.vue';
  import ProForecastCredits from '@/components/ProForecastCredits.vue';

  const props = defineProps({
    proForecast: {
      type: Object,
      required: true
    },
    hasExtendedForecast: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  });

  const proForecastStore = useProForecastStore();

  const forecaster = computed(() => proForecastStore.getForecaster(props.proForecast.forecaster_member_id));

</script>

<template>
  <ProForecastHeader 
    v-if="showHeader" 
    :proForecast="props.proForecast" 
    :forecaster="forecaster"
  />
  <ProForecastBodyDaily 
    v-if="proForecastStore.showDailyForecast" 
    :proForecast="props.proForecast" 
    :spotForecastSettings="proForecastStore.spotForecastSettings"
  />
  <ProForecastCredits 
    v-if="proForecastStore.showDailyForecast" 
    :proForecast="props.proForecast" 
    :forecaster="forecaster"
  />
  <ProForecastFooter 
    v-if="proForecastStore.showDailyForecast && props.hasExtendedForecast" 
    :proForecast="props.proForecast" 
    :midFooter="true"
  />
  <ProForecastBodyNextUpdateMessage 
    v-if="!proForecastStore.showDailyForecast" 
    :validDate="props.proForecast.valid_time_local_formatted"
    :timezone="props.proForecast.tz_name_short"
  />
</template>